import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LucideIconsModule } from '../../../../../../shared/lucide-icons.module';
import { CountrySelectorComponent } from '../../../../../../shared/components/country-selector/country-selector.component';
import { bindComponentViewModel } from '../../../../../../shared/utils/component-view-model.util';

@Component({
    selector: 'app-developer-property-edit-form',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, LucideIconsModule, CountrySelectorComponent],
    templateUrl: './developer-property-edit-form.component.html',
    styleUrls: ['./developer-property-edit-form.component.scss']
})
export class DeveloperPropertyEditFormComponent {

    activeDetailStep: any;
    activeDetailTab: any;
    addLandmark: any;
    addPaymentPlan: any;
    addPaymentPlanRow: any;
    addPlanScenario: any;
    addPlanScenarioPreset: any;
    applyLandmarkPreset: any;
    areaUnits: any;
    availableFeatures: any;
    bedroomOptions: any;
    canStripCopyTitle: any;
    clearFloorPlan: any;
    clearLayoutImage: any;
    currencies: any;
    currentStep: any;
    deleteImage: any;
    detailTabs: any;
    discountOptions: any;
    distanceUnits: any;
    error: any;
    effectivePaymentPlans: any;
    fieldInvalid: any;
    finishingOptions: any;
    floorPlanError: any;
    floorPlanLabel: any;
    floorSelectOptions: any;
    form: any;
    formattedPricePreview: any;
    furnishOptions: any;
    generateAutoPlan: any;
    handleImageUpload: any;
    images: any;
    inputClasses: any;
    isFeatureSelected: any;
    isUnitSecondaryBadgeDisabled: any;
    isUnitSecondaryBadgeSelected: any;
    landmarkPresets: any;
    landmarks: any;
    landmarksForm: any;
    layoutImageError: any;
    layoutImageLabel: any;
    loadingPhases: any;
    maintenanceModes: any;
    moveImage: any;
    nextStep: any;
    nextUploadIsMain: any;
    numberOfFloorsSelectOptions: any;
    onAreaToggle: any;
    onFeatureCheckboxChange: any;
    onFeatureValueInput: any;
    onFloorPlanSelected: any;
    onImageDragEnd: any;
    onImageDragOver: any;
    onImageDragStart: any;
    onImageDrop: any;
    onLayoutImageSelected: any;
    onProjectChange: any;
    onUnitBadgePrimaryChange: any;
    onUnitSecondaryBadgeToggle: any;
    openFloorPlan: any;
    openImageModal: any;
    openLayoutImage: any;
    openPropertyMediaPicker: any;
    paymentPlanRowAmountLabel: any;
    paymentPlanRows: any;
    paymentPlans: any;
    paymentPlansForm: any;
    phases: any;
    planGeneratorForm: any;
    planMode: any;
    planScenarioPreview: any;
    planScenarios: any;
    prevStep: any;
    publicPriceSource: any;
    publicPriceSourceHasIssue: any;
    publicPriceSourceHelpText: any;
    publicPriceSourceOptions: any;
    priceCurrencyLabel: any;
    projectLocationAddress: any;
    projectLocationLink: any;
    projects: any;
    property: any;
    propertyTypeSelectOptions: any;
    removeLandmark: any;
    removePaymentPlan: any;
    removePaymentPlanRow: any;
    removePlanScenario: any;
    resetPlanScenarios: any;
    save: any;
    saving: any;
    selectedFeatures: any;
    setPublicPriceSource: any;
    setActiveDetailTab: any;
    setMainImage: any;
    setPlanMode: any;
    setUseProjectLocation: any;
    steps: any;
    stripCopySuffix: any;
    paymentPlanManagerHref: any;
    unitBadgePrimaryOptions: any;
    unitBadgePrimaryValue: any;
    unitBadgeSecondaryLimit: any;
    unitBadgeSecondaryOptions: any;
    uploadError: any;
    uploadingFloorPlan: any;
    uploadingImage: any;
    uploadingLayoutImage: any;
    useProjectLocation: any;
    private _vm: any;

    @Input({ required: true })
    set vm(value: any) {
        this._vm = value;
        bindComponentViewModel(this, value, ['_vm']);
    }

    get vm(): any {
        return this._vm;
    }
}
